import { render, staticRenderFns } from "./Lightning2.vue?vue&type=template&id=fa886cba&"
import script from "./Lightning2.vue?vue&type=script&lang=js&"
export * from "./Lightning2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports